import { Button } from "@faire/web/slate/Button";
import { Column, Flex } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";

export const EROuterWrapper = styled(Column).attrs({
  align: "center",
  justify: "center",
})<{ $bgColor?: string }>`
  width: 100%;
  height: fit-content;
  padding: ${getSpacing("3x")};

  ${({ $bgColor }) =>
    $bgColor
      ? css`
          background-color: ${$bgColor};
        `
      : null}

  ${responsiveMediaQueries.tabletAndBelow} {
    padding: ${getSpacing("1x")};
  }
`;

export const ERInnerWrapper = styled(Flex).attrs({
  direction: { mobileAndAbove: "column", tabletAndAbove: "row" },
  justify: "center",
})`
  width: 100%;
  max-width: 1145px;

  ${responsiveMediaQueries.tabletAndBelow} {
    padding: ${getSpacing("3x")};
  }
  ${responsiveMediaQueries.desktopAndAbove} {
    padding: ${getSpacing("4x", "7x", "5x", "7x")};
  }
`;

export const ResponsiveRowOrColumnMobile = styled(Flex).attrs({
  direction: { mobileAndAbove: "column", tabletAndAbove: "row" },
})`
  &&& {
    ${responsiveMediaQueries.mobile} {
      width: 100%;
    }
  }
`;

export const WideButton = styled(Button)`
  width: 230px;

  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
`;

export const FullWidthButton = styled(Button)`
  width: 100%;
`;

export const StepColumn = styled(Column)`
  max-width: 615px;
  padding: ${getSpacing("10x", "8x")};

  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing("5x", "3x")};
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 690px;
`;

export const FullPageScreenColumn = styled(Column)`
  max-width: 615px;
  padding: ${getSpacing("10x", "8x")};
  ${responsiveMediaQueries.tabletAndAbove} {
    width: 100%;
  }
  ${responsiveMediaQueries.mobile} {
    max-width: 375px;
    padding: ${getSpacing("5x", "3x")};
  }
`;

export const NextButton = styled(Button)`
  width: 100%;

  ${responsiveMediaQueries.tabletAndAbove} {
    max-width: 342px;
  }
`;
